import { render, staticRenderFns } from "./AssignTeamNamePassiveStock.vue?vue&type=template&id=61bca0cc&scoped=true"
import script from "./AssignTeamNamePassiveStock.vue?vue&type=script&lang=js"
export * from "./AssignTeamNamePassiveStock.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamNamePassiveStock.vue?vue&type=style&index=0&id=61bca0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bca0cc",
  null
  
)

export default component.exports